// /az/careers — layout route (AZ). Pass-through <Outlet />.
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/az/careers")({
  component: () => <Outlet />,
});
